export const environment = {
  production: true,
  YOUR_MATOMO_SITE_ID:'2',
  YOUR_MATOMO_SERVER_URL:'https://analytics.metric-ceda.com/matomo/',
  // YOUR_MATOMO_SCRIPT_URL:'https://metric-ceda.com/matomo/js/container_9yFYDdcK.js'
  YOUR_MATOMO_SCRIPT_URL:'https://analytics.metric-ceda.com/matomo/js/matomo.js',
  WHATSAPP_URL: 'https://chat.4sysprod.com/wa',
  WA_UPLOAD_BASIC_AUTH_USERNAME: 'ivAiChatAgent',
  WA_UPLOAD_BASIC_AUTH_PASSWORD: '3+?wnrPYMxdQ2iH'
};
